module.exports = __webpack_public_path__ + "static/media/v3.b9ac58bd.mp4";